// extracted by mini-css-extract-plugin
module.exports = {"unregisterButton":"_388ed29"};